import { DestroyRef, Inject, Injectable } from '@angular/core';
import { CrmObjectService } from '../../shared-services';
import { CrmObjectInterface } from '@vendasta/crm';
import { map, BehaviorSubject, Observable, debounceTime, switchMap, tap, shareReplay, filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable()
export class CompanyBatchGetterService {
  constructor(
    @Inject(DestroyRef) private destroyRef: DestroyRef,
    private readonly crmObjectService: CrmObjectService,
  ) {
    this.newCompanyId$$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((companyId) => {
      if (!companyId) {
        return;
      }
      const batchedCompanyIds = [...this.batchCompanyIds$$.value];
      if (!batchedCompanyIds.includes(companyId)) {
        batchedCompanyIds.push(companyId);
        this.batchCompanyIds$$.next(batchedCompanyIds);
      }
    });
    this.lastBatch$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  private newCompanyId$$ = new BehaviorSubject<string>('');
  private batchCompanyIds$$ = new BehaviorSubject<string[]>([]);
  private lastBatch$ = this.batchCompanyIds$$.pipe(
    filter((batchCompanyIds) => batchCompanyIds.length > 0),
    debounceTime(1),
    map((batchCompanyIds) => [...new Set(batchCompanyIds)]),
    switchMap((batchCompanyIds) => this.crmObjectService.getMultiObject('Company', batchCompanyIds)),
    map((response) => response.crmObjects),
    tap(() => {
      this.batchCompanyIds$$.next([]);
    }),
    shareReplay(1),
  );

  getCompany(companyId: string): Observable<CrmObjectInterface> {
    this.newCompanyId$$.next(companyId);
    return this.lastBatch$.pipe(map((companies) => companies.find((company) => company?.crmObjectId === companyId)));
  }
}
